import styled from 'styled-components';

// Selective dot-matrix divider: a dotted LED-like rule in the signal-red
// accent. Decorative only (aria-hidden at usage site).
const DotDivider = styled.div`
  height: 6px;
  width: 100%;
  background-image: radial-gradient(
    circle,
    ${props => props.theme.colors.primary} 1.4px,
    transparent 1.5px
  );
  background-size: 12px 6px;
  background-repeat: repeat-x;
  background-position: center;
  opacity: 0.55;
`;

export default DotDivider;
